// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BrandsBlock_wrapper__i8Htn","brandsBlock":"BrandsBlock_brandsBlock__4aYEK","heading":"BrandsBlock_heading__mXibc","grid__item":"BrandsBlock_grid__item__6DJv_"};